module.exports = __webpack_public_path__ + "static/media/galdinsLose_50000.21bf2f81.png";